import * as firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/remote-config'
import 'firebase/messaging'

import { isFirebaseMessagingSupported } from '../utils'
import { BASE_URL } from '../config/URL'
import firebaseConfig from './firebaseConfig'

firebase.initializeApp(firebaseConfig)
export const firebaseAnalytic = firebase.analytics()
export const messaging = isFirebaseMessagingSupported()
  ? firebase.messaging()
  : {}

export const remoteConfig = firebase.remoteConfig()

const nodeEnv = process.env.REACT_APP_NODE_ENV
export const defaultConfigBaseUrl = BASE_URL

const firebaseConfigKeys = {
  production: {
    maintenance: 'isMaintenance',
    baseUrl: 'userApiBaseUrl',
  },
  staging: {
    maintenance: 'isMaintenanceUat',
    baseUrl: 'userApiBaseUrlUat',
  },
  development: {
    maintenance: 'isMaintenanceDev',
    baseUrl: 'userApiBaseUrlDev',
  },
}
export const configKeys = {
  isMaintenance: firebaseConfigKeys[nodeEnv].maintenance,
  userApiBaseUrl: firebaseConfigKeys[nodeEnv].baseUrl,
}

remoteConfig.settings.minimumFetchIntervalMillis =
  nodeEnv === 'production' ? 3600000 : 900000
remoteConfig.defaultConfig = {
  isMaintenance: false,
  isMaintenanceUat: false,
  isMaintenanceDev: false,
  userApiBaseUrl: defaultConfigBaseUrl,
  userApiBaseUrlUat: defaultConfigBaseUrl,
  userApiBaseUrlDev: defaultConfigBaseUrl,
}
